import { faBedPulse, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from "react-bootstrap";

/**
 * Loading patient box
 */
export const LoadingPatient = () => {
    return (
        <>
            <Container fluid style={{ position: 'fixed', top: '240px', zIndex: 998, paddingTop: '4px' }}>
                <Row className="mt-2 mb-2">
                    <Col md={1}></Col>
                    <Col md={10}>
                        <p style={{ textAlign: 'center' }}>
                            <FontAwesomeIcon icon={faSpinner} spin />{' '}Loading patient...
                        </p>
                    </Col>
                    <Col md={1}></Col>
                </Row>
            </Container>
        </>
    );
};
